import React from 'react';
import { BottomFooterLinks } from './index';

const FooterBottom: React.FC = () => {
  return (
    <ul>
      {BottomFooterLinks.map((listElement, index) => (
        <li key={index} id={listElement.displayName}>
          <a
            href={listElement.url}
            target="_blank"
            rel="noopener noreferrer"
            data-gi="footer-link"
            onClick={listElement.onClick}
          >
            {listElement.displayName}
          </a>
        </li>
      ))}
    </ul>
  );
};

export { FooterBottom };
